<div class="dashboard-layout">
  <div class="sidebar" [class.collapsed]="isCollapsed">
    <div class="sidebar-header" [class.collapsed]="isCollapsed">
      <img [src]="isCollapsed ? 'icons/Empresas_CEC_BI_Logo_Compact.svg' : 'icons/Empresas_CEC_BI_Logo.svg'" alt="Logo">
    </div>

    <div class="sidebar-menu no-scroll-bar">
      <div *ngIf="canAccessDashboard"
           class="menu-item"
           [class.active]="title === (!isAdmin ? 'Inicio' : 'Inicio de Administración')"
           (click)="navigate( '/app/dashboard-company')"
           [nz-tooltip]="isCollapsed ? (!isAdmin ? 'Inicio' : 'Inicio de Administración') : null"
           nzTooltipPlacement="right">
        <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="home" size="base"></app-icon>
        <span *ngIf="!isCollapsed">{{ !isAdmin ? 'Inicio' : 'Inicio' }}</span>
      </div>

      <!-- Vistas de usuario también disponibles para empresas -->
      <div *ngIf="canReadFavorite && !canAccessDashboard"
           class="menu-item"
           [class.active]="title === 'Inicio Usuario'"
           (click)="navigate('/app/dashboard-user')"
           [nz-tooltip]="isCollapsed ? 'Inicio Usuario' : null"
           nzTooltipPlacement="right">
        <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="home" size="base"></app-icon>
        <span *ngIf="!isCollapsed">Inicio</span>
      </div>

      <!-- Menú de Reportes con submenús para usuarios -->
<!--      <div *ngIf="canReadReports && !isAdmin" [class.collapse-submenu-group]="isCollapsed">-->
<!--        <div class="menu-item dropdown"-->
<!--             [class.expanded]="isReportsExpanded"-->
<!--             [class.expanded-and-collapse]="isReportsExpanded && isCollapsed"-->
<!--             [class.submenu-active]="isReportsActive()"-->
<!--             (click)="toggleReportsDropdown()"-->
<!--             [nz-tooltip]="isCollapsed ? 'Reportes' : null"-->
<!--             nzTooltipPlacement="right">-->
<!--          <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="file-bar-chart" size="base"></app-icon>-->
<!--          <span *ngIf="!isCollapsed">Reportes</span>-->
<!--          <app-icon *ngIf="!isCollapsed" name="chevron-down" size="base" class="dropdown-arrow"></app-icon>-->
<!--        </div>-->
<!--        <div [class]="'submenu-container' + (isReportsExpanded ? ' show' : '')"-->
<!--             [style.display]="isCollapsed ? 'flex' : 'flex'">-->
<!--          @for (report of currentUser!.reports; track report.id) {-->
<!--            <div class="submenu-item"-->
<!--                 [class.active]="title === report.name"-->
<!--                 (click)="navigate('/app/reports-user/' + report.key)"-->
<!--                 [nz-tooltip]="isCollapsed ? report.name : null"-->
<!--                 nzTooltipPlacement="right">-->
<!--              <app-icon [class.text-primary]="title === report.name" [name]="report.icon || 'file'" size="base"></app-icon>-->
<!--              <span>{{report.name}}</span>-->
<!--            </div>-->
<!--          }-->
<!--          <div class="submenu-item"-->
<!--               [class.active]="title === 'Reportes'"-->
<!--               (click)="navigate('/app/reports-general-view')"-->
<!--               [nz-tooltip]="isCollapsed ? 'Ver todos' : null"-->
<!--               nzTooltipPlacement="right">-->
<!--            <app-icon [class.text-primary]="title === 'Reportes'" name="files" size="base"></app-icon>-->
<!--            <span>Ver todos</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div *ngIf="canReadFavorite && !canAccessDashboard"
           class="menu-item"
           [class.active]="title === 'Reportes'"
           (click)="navigate('/app/reports-general-view')"
           [nz-tooltip]="isCollapsed ? 'Inicio Usuario' : null"
           nzTooltipPlacement="right">
        <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="folder" size="base"></app-icon>
        <span *ngIf="!isCollapsed">Reportes</span>
      </div>

      <ng-container>
        <!-- Menú de Gestión de Reportes desplegable -->
        <div *ngIf="canReadReports && isAdmin" [class.collapse-submenu-group]="isCollapsed">
          <div class="menu-item dropdown"
               [class.expanded]="isManagementExpanded"
               [class.expanded-and-collapse]="isManagementExpanded && isCollapsed"
               [class.submenu-active]="title === 'Gestión de Reportes' || title === 'Logs de Exportación'"
               (click)="toggleManagementDropdown()"
               [nz-tooltip]="isCollapsed ? 'Gestión de Reportes' : null"
               nzTooltipPlacement="right">
            <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="folder" size="base"></app-icon>
            <span *ngIf="!isCollapsed">Gestión de Reportes</span>
            <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" *ngIf="!isCollapsed" name="chevron-down" size="base" class="dropdown-arrow"></app-icon>
          </div>

          <div [class]="'submenu-container' + (isManagementExpanded ? ' show' : '')"
               [style.display]="isCollapsed ? 'flex' : 'flex'">
            <div class="submenu-item"
                 [class.active]="title === 'Gestión de Reportes'"
                 (click)="navigate('/app/reports-company')"
                 [nz-tooltip]="isCollapsed ? 'Todos los reportes' : null"
                 nzTooltipPlacement="right">
              <app-icon [class.text-primary]="title === 'Gestión de Reportes'" name="files" size="base"></app-icon>
              <span>Todos los reportes</span>
            </div>
<!--            <div class="submenu-item"-->
<!--                 [class.active]="title === 'Logs de Exportación'"-->
<!--                 (click)="navigate('/app/logs')"-->
<!--                 [nz-tooltip]="isCollapsed ? 'Logs de Exportación' : null"-->
<!--                 nzTooltipPlacement="right">-->
<!--              <app-icon [class.text-primary]="title === 'Logs de Exportación'" name="download" size="base"></app-icon>-->
<!--              <span>Logs de Exportación</span>-->
<!--            </div>-->
          </div>
        </div>

        <div *ngIf="canAccessUsers || isAdmin"
             class="menu-item"
             [class.active]="title === 'Usuarios'"
             (click)="navigate('/app/users')"
             [nz-tooltip]="isCollapsed ? 'Usuarios' : null"
             nzTooltipPlacement="right">
          <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="users" size="base"></app-icon>
          <span *ngIf="!isCollapsed">Usuarios</span>
        </div>

        <div *ngIf="canAccessRoles || isAdmin"
             class="menu-item"
             [class.active]="title === 'Roles & Permisos'"
             (click)="navigate('/app/roles')"
             [nz-tooltip]="isCollapsed ? 'Roles & Permisos' : null"
             nzTooltipPlacement="right">
          <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="shield" size="base"></app-icon>
          <span *ngIf="!isCollapsed">Roles & Permisos</span>
        </div>

        <div *ngIf="canAccessIntegrations || isAdmin"
             class="menu-item"
             [class.active]="title === 'Integraciones'"
             (click)="navigate('/app/integrations')"
             [nz-tooltip]="isCollapsed ? 'Integraciones' : null"
             nzTooltipPlacement="right">
          <app-icon [color]="isCollapsed ? '#64748B' : '#00A360'" name="zap" size="base"></app-icon>
          <span *ngIf="!isCollapsed">Integraciones</span>
        </div>
      </ng-container>
    </div>

    <div class="sidebar-footer">
      <div class="brand">
        <div class="mini-card">
          <app-icon color="#000" [size]="'lg'" name="users"></app-icon>
        </div>
        <div class="brand-text" *ngIf="!isCollapsed">
          <p class="brand-title fs-sm text-semibold text-nowrap">{{ !isAdmin ? 'Panel Usuario' : 'Panel Empresarial' }}</p>
          <p class="brand-subtitle fs-xs text-nowrap">{{ currentUser?.email || 'user@email.com' }}</p>
        </div>
      </div>

      <div class="flex flex-column gap-8">
        <button nz-button nzType="default" class="w-100" (click)="openUserDrawer()">
          <app-icon name="user" size="base"></app-icon>
          <span *ngIf="!isCollapsed">Mi sesión</span>
        </button>


        <button nz-button nzType="default" class="w-100" (click)="openConfirmLogout()">
          <app-icon name="log-out" size="base"></app-icon>
          <span *ngIf="!isCollapsed">Cerrar sesión</span>
        </button>
      </div>
    </div>
  </div>

  <div class="main-content" [class.sidebar-collapsed]="isCollapsed">
    <div class="header">
      <button class="collapse-btn" (click)="toggleSidebar()">
        <app-icon [name]="isCollapsed ? 'panel-right' : 'panel-left'" size="base"></app-icon>
      </button>
      <div class="header-text">
        <div class="header-title fs-xl text-semibold text-dark">{{ title }}</div>
        <div class="header-description fs-sm text-dark">{{ description }}</div>
      </div>
      <div class="header-actions">

          <nz-badge
            [nzDot]="exportCount > 0"
            [nzStyle]="{ backgroundColor: '#008f52'}"
            [nzOffset]="[-12, 6]">
            <button
              nz-button
              nzType="text"
              class="export-tracking-btn"
              (click)="toggleExportTracking()"
              [nz-tooltip]="'Exportaciones'"
              nzTooltipPlacement="bottom">
              <app-icon name="download" size="base"></app-icon>
            </button>
          </nz-badge>

      </div>
    </div>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- Componente de seguimiento de exportaciones -->
<app-export-tracking
  [isVisible]="showExportTracking"
  (close)="showExportTracking = false">
</app-export-tracking>
